<template>
  <div class="modal_container">
    <div class="modal">
      <div class="modal-content">
        <div class="caption">
          <div class="title">{{textContent.titleAdd}}</div>
          <div @click="modalClose" class="close"></div>
        </div>
        <div class="modal-scroll">
          <form v-on:submit.prevent="addItem">
            <form-input name="title"></form-input>
            <form-input name="url"></form-input>
            <form-file use-case="cover" name="img"></form-file>
            <form-input name="seo_alt"></form-input>
          </form>
          <div class="buttons">
            <div class="next">
              <button @click="modalClose" class="cancel">{{textContent.cancelButton}}</button>
              <button class="confirm" @click="addItem">{{textContent.submitButton}} &#8594;</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import FormInput from '@/components/create-form/Input'
  import {createNamespacedHelpers} from 'vuex'
  import FormTextArea from '@/components/create-form/TextArea'
  import FormFile from '@/components/create-form/File'
  import Tabs from '@/components/create-form/Tabs'

  const {mapMutations, mapGetters, mapActions, mapState} = createNamespacedHelpers('mainPage')

  export default {
    computed: {
      ...mapState([
        'textContent'
      ]),
      ...mapGetters([
        'isLastTab'
      ])
    },
    methods: {
      ...mapActions([
        'modalClose',
        'addItem',
        'initFields',
        'onNext',
        'onPrev'
      ]),
      ...mapMutations([
        'setTabs',
        'setCurrentTabId',
        'setFileExtensions'
      ]),
    },
    created () {
      this.setCurrentTabId(0)
      this.setFileExtensions({img: ['jpg', 'jpeg', 'png', 'gif']})
      this.initFields({
        title: {
          value: '',
          parameterName: 'title',
          name: 'Заголовок',
          errorId: null,
          errors: {empty: 'Введите заголовок'},
          tabId: 0
        },
        url: {
          value: '',
          parameterName: 'url',
          name: 'Ссылка',
          errorId: null,
          errors: {empty: 'Введите ссылку на сайт'},
          tabId: 0
        },
        seo_alt: {
          value: '',
          parameterName: 'seo_alt',
          name: 'Альтернативный текст',
          errorId: null,
          isNullable: true,
          errors: {empty: 'Введите альтернативный текст'},
          tabId: 0
        },
        img: {
          value: '',
          parameterName: 'img',
          name: 'Изображение',
          errorId: null,
          errors: {empty: 'Выберите изображение', extension: 'Допустимые расширения: jpg, jpeg, png, gif'},
          fileName: '',
          tabId: 0
        },
      })
    },
    components: {
      FormInput,
      FormTextArea,
      FormFile,
      Tabs
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/partners/CreateModal.vue